/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Properties_NewInputs */

const cs_properties_new = /** @type {(inputs: Properties_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nová nemovitost`)
};

const en_properties_new = /** @type {(inputs: Properties_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New property`)
};

/**
* | output |
* | --- |
* | "New property" |
*
* @param {Properties_NewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const properties_new = /** @type {((inputs?: Properties_NewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Properties_NewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_properties_new(inputs)
	return cs_properties_new(inputs)
});